export default __webpack_public_path__ + "static/media/shadow-cold-summer.696aeafd.png";